module.exports = __webpack_public_path__ + "static/10-837f6a46caaee2f746611611c81aabf5.jpg";